import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { spacing } = lightTheme;

const styles: Record<string, SxProps> = {
  carouselWrapper: {
    '&.MarketingPropertyCardSection': {
      paddingY: spacing(2)
    }
  },
  foxtonsTeam: {
    padding: {
      xs: spacing(0.5),
      md: spacing(0.5)
    },
    paddingLeft: {
      xs: 0,
      md: spacing(0.5)
    },
    height: '100%'
  }
};

export default styles;
